<div class="network--wrapper" *ngIf="!!selectedChain">
    <div class="network" (click)="showSelector = true">
        <div class="chain--info">
            <div class="currency__icon-wrapper">
                <img
                    alt=""
                    class="currency__icon"
                    [src]="
                        '/assets/images/symbols/' +
                        (baseSymbol | lowercase) +
                        '.svg'
                    "
                />
            </div>
            <p class="title">Blockchain</p>
            <p class="text text--color-secondary text--size-s">
                {{ selectedChain.full_name }}
            </p>
        </div>
        <div class="other--details">
            <p
                class="text text--color-seondary text--size-s"
                *ngIf="selectedChain.testnet"
            >
                (TESTNET)
            </p>
            <div class="arrow arrow--right"></div>
        </div>
    </div>
</div>
<div class="page" *ngIf="showSelector">
    <div class="page-head">
        <app-back (click)="showSelector = false"></app-back>
        <h1 class="title title--size-l text--center">Address Standard</h1>
    </div>
    <div class="page-content page-content--padding-top">
        <ng-container *ngFor="let chain of activeNetworks">
            <div
                class="network--wrapper page-row selectable"
                (click)="selectNetwork(chain)"
            >
                <div class="network">
                    <div class="chain--info">
                        <div class="currency__icon-wrapper">
                            <img
                                alt=""
                                class="currency__icon"
                                [src]="
                                    '/assets/images/symbols/' +
                                    (chain.baseSymbol | lowercase) +
                                    '.svg'
                                "
                            />
                        </div>
                        <p class="title"></p>
                        <p class="text text--size-l">
                            {{ chain.full_name }}
                        </p>
                    </div>
                    <div class="other--details">
                        <p
                            class="text text--color-seondary text--size-s"
                            *ngIf="chain.testnet"
                        >
                            (TESTNET)
                        </p>
                        <div class="arrow arrow--right"></div>
                    </div>
                </div>
            </div>
        </ng-container>
    </div>
</div>
